// Yes, this is correct - top level is above _everything_ else, including i18n
/* eslint-disable i18next/no-literal-string */

// This is a top level error fallback that allows users to reload the app
// If an exception is thrown that is not caught by any other error boundary, this will be shown
export function TopLevelErrorFallback() {
  return (
    <div className="flex h-screen w-screen items-center justify-center rounded-3xl bg-core-tertiary">
      <div className="text-center">
        <div className="mb-5 text-headline-large">Something went wrong.</div>
        <button
          // our buttons rely on settings, and at this level settings will not be available
          // so we manually style the button here
          className="relative h-fit min-h-13 w-fit min-w-30 rounded-2xl bg-core-primary px-3 py-1 text-xs leading-[normal] font-semibold text-core-on-primary select-none hover:opacity-80 disabled:opacity-30 md:min-w-38 md:px-5 md:text-sm"
          onClick={() => window.location.reload()}
        >
          Try again
        </button>
      </div>
    </div>
  )
}
